import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  deleteExecutiveSummaryFileContent,
  restoreExecutiveSummaryFileContent,
  uploadExecutiveSummaryFileContent,
} from './index';

export const createNominationExecutiveSummaryFileContentApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  uploadExecutiveSummaryFileContent: (instance: IPublicClientApplication, nominationId: number, documentContent: File) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => uploadExecutiveSummaryFileContent(fetchContext, nominationId, documentContent, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('uploadExecutiveSummaryFileContent', isInFlight);
    },
  ),
  deleteExecutiveSummaryFileContent: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteExecutiveSummaryFileContent(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteExecutiveSummaryFileContent', isInFlight);
    },
  ),
  restoreExecutiveSummaryFileContent: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => restoreExecutiveSummaryFileContent(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('restoreExecutiveSummaryFileContent', isInFlight);
    },
  ),
});
